import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'
// Stoyan
export const useProtocolById = (projectId: string, protocolId: string) => {
  const p = ENDPOINTS.PROTOCOLS.GET_ONE(projectId, protocolId)

  const { data, mutate, error } = useSWR(p, getReq, { suspense: true })

  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
